var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaluateLoan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add_circle_outline-white copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loan-Creation-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Evaluate-Loan",
    transform: "translate(-666.000000, -601.000000)",
    fill: "#32325D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-/-with-Left_-icon/Secondary/Default-Copy-2",
    transform: "translate(651.000000, 589.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Dark-/-Eeveluate",
    transform: "translate(14.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "none",
    transform: "translate(1.000000, 1.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6,0 L1.4,0 C0.63,0 0,0.65 0,1.44444444 L0,11.5555556 C0,12.35 0.63,13 1.4,13 L12.6,13 C13.37,13 14,12.35 14,11.5555556 L14,1.44444444 C14,0.65 13.37,0 12.6,0 Z M12.6,11.5555556 L1.4,11.5555556 L1.4,1.44444444 L12.6,1.44444444 L12.6,11.5555556 Z",
    id: "Shape",
    fill: "#32325D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#32325D",
    points: "12.187 5.35888889 11.193 4.33333333 8.974 6.62277778 7.987 5.59722222 7 6.61555556 8.974 8.66666667"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#32325D",
    x: 2.1,
    y: 2.88888889,
    width: 3.5,
    height: 1.44444444
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#32325D",
    x: 2.1,
    y: 5.77777778,
    width: 3.5,
    height: 1.44444444
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#32325D",
    x: 2.1,
    y: 8.66666667,
    width: 3.5,
    height: 1.44444444
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluateLoan);
export default __webpack_public_path__ + "static/media/evaluate_loan.1d2ce8092d9eba94338654efb0ca87b7.svg";
export { ForwardRef as ReactComponent };